import { Component,OnInit} from '@angular/core';

declare var google: any;

@Component({
  selector: 'app-cameras',
  templateUrl: './cameras.component.html',
  styleUrls: ['./cameras.component.css']
})
export class CamerasComponent implements OnInit{
  ngOnInit() {
    google.charts.load('current', { packages: ['corechart'] });
    google.charts.setOnLoadCallback(this.drawChart);
  }

  drawChart() {
    const Data2 = new google.visualization.DataTable();
    Data2.addColumn('string', 'Camera Versions');
    Data2.addColumn('number', 'Number of Devices');
    Data2.addRows([
      ['1033-MISSION4-rl:331-OVT1', 7329],
      ['1088-MISSION5-rl:326-OVT6', 853],
      ['1071-MISSION4-rl:763-OVT1', 643],
      ['1056-MISSION6-rl:372-OVT9', 265],
      ['1002-MISSION4-rl:264-OVT0', 99],
      ['1072-MISSION7-rl:325-OVT1', 48],
      ['1020-MISSION9-rl:767-OVT5', 9],
      ['1001-MISSION10-rl:213-OVT2',111],
      ['1025-MISSION11-rl:768-OVT1', 98]
    ]);

    const options = {
      title: 'Camera Versions',
      width: 400,
      height: 400,
      is3D: true
    };

    const chart = new google.visualization.PieChart(document.getElementById('cameras'));
    chart.draw(Data2, options);
  }


}
